import { createSelector } from 'reselect';


const getModules = state => state.training.modules;


export const getTrainingModules = createSelector(
  [getModules], 
  (modules) => {
    modules.map(programModules => 
      programModules.program.incompletedModules = programModules.trainingModules.filter(
        module => module.submodules.length != module.submodules.filter(
          submodule => submodule.tasks.every(task => task.completed)
        ).length
      ).length
    );
    return modules;
  }
)